module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rintro"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0007#intro"
    }
  }, [_vm._v("Introduction: Data and the Matter of Black Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahaftintro01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0007#ahaftintro01"
    }
  }, [_vm._v("Undisciplining Data")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahintro01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0007#ahintro01"
    }
  }, [_vm._v("The Social Life of Racial Data")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahintro02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0007#ahintro02"
    }
  }, [_vm._v("Racial Data, Visual Revolutions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahintro03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0007#ahintro03"
    }
  }, [_vm._v("The Aesthetics of Data")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahintro04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0007#ahintro04"
    }
  }, [_vm._v("Undisciplining as Method")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahintro05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0007#ahintro05"
    }
  }, [_vm._v("Overview")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0008#ch01"
    }
  }, [_vm._v("1 · The Social Survey: The Survey Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahaft0101"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0008#ahaft0101"
    }
  }, [_vm._v("“The Survey Spirit”: Origins, Evolution, and the Radical Operations of the Social Survey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0101"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0008#ah0101"
    }
  }, [_vm._v("“Ugly Facts” and (Anti)Social Data: Kelly Miller, the American Negro Academy, and the Call for the Social Survey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0102"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0008#ah0102"
    }
  }, [_vm._v("A Book to Do Some Good: Kelly Miller, Sutton Griggs, and the Emergence of Social Document Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0103"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0008#ah0103"
    }
  }, [_vm._v("Faulty Surfaces, Unruly Eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0104"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0008#ah0104"
    }
  }, [_vm._v("Everywhere and Nowhere: The Social Survey’s Nongeography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0009#ch02"
    }
  }, [_vm._v("2 · Photography: Looking Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahaft0201"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0009#ahaft0201"
    }
  }, [_vm._v("Seeing Survival")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0201"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0009#ah0201"
    }
  }, [_vm._v("Deep Black Mourning: Lynching’s (Anti)Photographic Logic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0202"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0009#ah0202"
    }
  }, [_vm._v("“Let Them See”: Photography, Performance, and Reform")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0203"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0009#ah0203"
    }
  }, [_vm._v("Looking Out: Toward a New Visual Epistemology of Survival")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0204"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0009#ah0204"
    }
  }, [_vm._v("Photographically Hesitant: The Visual Politics of W. E. B. Du Bois’s “Jesus Christ in Georgia”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0010#ch03"
    }
  }, [_vm._v("3 · Film: Overexposure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rahaft0301"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0010#ahaft0301"
    }
  }, [_vm._v("Beyond the Frame: Overexposure and Zora Hurston’s Filmic Practice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0301"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0010#ah0301"
    }
  }, [_vm._v("“Drenched in Light”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0302"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0010#ah0302"
    }
  }, [_vm._v("Recording Racial Feeling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0303"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0010#ah0303"
    }
  }, [_vm._v("Contraband Flesh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rah0304"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0010#ah0304"
    }
  }, [_vm._v("Cinematics of Negro Expression")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rcoda"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0011#coda"
    }
  }, [_vm._v("Coda: Racial Data’s Afterlives")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rplates"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0012#plates"
    }
  }, [_vm._v("Color plates")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "racknow"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0013#acknow"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rnotes"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0014#notes"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbm",
    attrs: {
      "id": "rindex"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiwomack0015#index"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78d1c150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-womack-0006.vue
// module id = 69
// module chunks = 0